import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 288 400"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M277.698 0H10.302C4.612 0 0 4.612 0 10.302V389.698C0 395.388 4.612 400 10.302 400H277.698C283.388 400 288 395.388 288 389.698V10.302C288 4.612 283.388 0 277.698 0Z"
      fill="#BDE0F1"
    />
    <path
      d="M144 208C183.765 208 216 175.765 216 136C216 96.2355 183.765 64 144 64C104.235 64 72 96.2355 72 136C72 175.765 104.235 208 144 208Z"
      fill="#05C031"
    />
    <path
      d="M137.821 160.87C134.315 160.87 131.018 159.505 128.54 157.025L107.804 136.29C104.875 133.361 104.875 128.612 107.804 125.684C110.734 122.755 115.482 122.754 118.411 125.684L137.821 145.095L169.589 113.327C172.519 110.398 177.267 110.398 180.196 113.327C183.125 116.256 183.125 121.005 180.196 123.933L147.103 157.026C144.623 159.505 141.327 160.87 137.821 160.87Z"
      fill="#F2FBFF"
    />
    <path
      d="M240 311.5H80C75.857 311.5 72.5 308.142 72.5 304C72.5 299.858 75.857 296.5 80 296.5H240C244.143 296.5 247.5 299.858 247.5 304C247.5 308.142 244.143 311.5 240 311.5Z"
      fill="#1D7894"
    />
    <path
      d="M240 279.5H80C75.857 279.5 72.5 276.142 72.5 272C72.5 267.858 75.857 264.5 80 264.5H240C244.143 264.5 247.5 267.858 247.5 272C247.5 276.142 244.143 279.5 240 279.5Z"
      fill="#1D7894"
    />
    <path
      d="M240 343.5H80C75.857 343.5 72.5 340.142 72.5 336C72.5 331.858 75.857 328.5 80 328.5H240C244.143 328.5 247.5 331.858 247.5 336C247.5 340.142 244.143 343.5 240 343.5Z"
      fill="#1D7894"
    />
    <path
      d="M48 279.5C52.1421 279.5 55.5 276.142 55.5 272C55.5 267.858 52.1421 264.5 48 264.5C43.8579 264.5 40.5 267.858 40.5 272C40.5 276.142 43.8579 279.5 48 279.5Z"
      fill="#1D7894"
    />
    <path
      d="M48 311.5C52.1421 311.5 55.5 308.142 55.5 304C55.5 299.858 52.1421 296.5 48 296.5C43.8579 296.5 40.5 299.858 40.5 304C40.5 308.142 43.8579 311.5 48 311.5Z"
      fill="#1D7894"
    />
    <path
      d="M48 343.5C52.1421 343.5 55.5 340.142 55.5 336C55.5 331.858 52.1421 328.5 48 328.5C43.8579 328.5 40.5 331.858 40.5 336C40.5 340.142 43.8579 343.5 48 343.5Z"
      fill="#1D7894"
    />
  </svg>,
  "ExternalInvoice"
);
